// import React from 'react';
// import styles from './UserManagement.module.css';

// const UserTable = ({ users, loading, onEdit, onDelete, onHistory, expandedRows, onToggleRow }) => {
//     const getInitials = (name) => {
//         if (!name) return '?';
//         const parts = name.split(' ');
//         return parts.length >= 2 ? (parts[0][0] + parts[1][0]).toUpperCase() : name.substring(0, 2).toUpperCase();
//     };

//     if (loading) {
//         return (
//             <div style={{ textAlign: 'center', padding: '40px', fontSize: '16px', color: '#666' }}>
//                 Loading users...
//             </div>
//         );
//     }

//     if (users.length === 0) {
//         return (
//             <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
//                 No users found
//             </div>
//         );
//     }

//     return (
//         <table className={styles.table}>
//             <thead className={styles.tableHead}>
//                 <tr>
//                     <th style={{ width: '50px' }}></th>
//                     <th>Full Name</th>
//                     <th>Contact Number</th>
//                     <th>Role</th>
//                     <th>Study</th>
//                     <th>Assigned Studies</th>
//                     <th>Status</th>
//                     <th className={styles.actionsColumn}>Actions</th>
//                 </tr>
//             </thead>
//             <tbody className={styles.tableBody}>
//                 {users.map((user) => (
//                     <React.Fragment key={user.user_id}>
//                         <tr className={styles.tableRow}>
//                             <td>
//                                 <button
//                                     className={styles.expandButton}
//                                     onClick={() => onToggleRow(user.user_id)}
//                                 >
//                                     <svg
//                                         width="16"
//                                         height="16"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         strokeWidth="2"
//                                         className={expandedRows.has(user.user_id) ? styles.expandedIcon : ''}
//                                     >
//                                         <polyline points="9 18 15 12 9 6" />
//                                     </svg>
//                                 </button>
//                             </td>
//                             <td>
//                                 <div className={styles.userCell}>
//                                     <div className={styles.avatar}>{getInitials(user.full_name)}</div>
//                                     <div className={styles.userInfo}>
//                                         <div className={styles.userName}>{user.full_name}</div>
//                                         <div className={styles.userEmail}>{user.email_address}</div>
//                                     </div>
//                                 </div>
//                             </td>
//                             <td>{user.contact_number || '-'}</td>
//                             <td><span className={styles.roleBadge}>{user.role_name || '-'}</span></td>
//                             <td>{user.study_title || '-'}</td>
//                             <td>
//                                 <span className={styles.sitesCount}>
//                                     {user.assigned_sites?.length || 0} {user.assigned_sites?.length === 1 ? 'site' : 'sites'}
//                                 </span>
//                             </td>
//                             <td>
//                                 <span className={`${styles.statusBadge} ${user.status === 'Active' ? styles.statusActive : styles.statusInactive}`}>
//                                     {user.status}
//                                 </span>
//                             </td>
//                             <td>
//                                 <div className={styles.actionIcons}>
//                                     <button className={styles.iconButton} onClick={() => onEdit(user)} title="Edit">
//                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                             <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                                             <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                                         </svg>
//                                     </button>
//                                     <button className={styles.iconButton} onClick={() => onDelete(user)} title="Delete">
//                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                             <polyline points="3 6 5 6 21 6" />
//                                             <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
//                                         </svg>
//                                     </button>
//                                     <button className={styles.iconButton} onClick={() => onHistory(user)} title="History">
//                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                             <circle cx="12" cy="12" r="10" />
//                                             <polyline points="12 6 12 12 16 14" />
//                                         </svg>
//                                     </button>
//                                 </div>
//                             </td>
//                         </tr>
//                         {expandedRows.has(user.user_id) && (
//                             <tr className={styles.expandedRow}>
//                                 <td colSpan="8">
//                                     <div className={styles.expandedContent}>
//                                         <div className={styles.siteAssignmentsHeader}>
//                                             <div className={styles.siteHeaderItem}>
//                                                 <span className={styles.headerLabel}>Study Details</span>
//                                             </div>
//                                             <div className={styles.siteHeaderItem}>
//                                                 <span className={styles.headerLabel}>Site Details</span>
//                                             </div>
//                                             <div className={styles.siteHeaderItem}>
//                                                 <span className={styles.headerLabel}>Max. Subjects</span>
//                                             </div>
//                                             <div className={styles.siteHeaderItem}>
//                                                 <span className={styles.headerLabel}>Currency</span>
//                                             </div>
//                                             <div className={styles.siteHeaderItem}>
//                                                 <span className={styles.headerLabel}>Service Fee</span>
//                                             </div>
//                                             <div className={styles.siteHeaderItem}>
//                                                 <span className={styles.headerLabel}>Consent Template</span>
//                                             </div>
//                                         </div>
//                                         {user.assigned_sites && user.assigned_sites.length > 0 ? (
//                                             user.assigned_sites.map((assignment, index) => (
//                                                 <div key={index} className={styles.siteAssignmentRow}>
//                                                     <div className={styles.siteAssignmentItem}>
//                                                         <div className={styles.siteDetailText}>{assignment.study_number || 'N/A'}</div>
//                                                         <div className={styles.siteDetailSubtext}>{assignment.study_name || 'N/A'}</div>
//                                                     </div>
//                                                     <div className={styles.siteAssignmentItem}>
//                                                         <div className={styles.siteDetailText}>{assignment.site_code || 'N/A'}</div>
//                                                         <div className={styles.siteDetailSubtext}>{assignment.site_name || 'N/A'}</div>
//                                                     </div>
//                                                     <div className={styles.siteAssignmentItem}>
//                                                         <div className={styles.siteDetailText}>{assignment.max_subjects || '20'}</div>
//                                                     </div>
//                                                     <div className={styles.siteAssignmentItem}>
//                                                         <div className={styles.siteDetailText}>{assignment.currency || 'USD'}</div>
//                                                     </div>
//                                                     <div className={styles.siteAssignmentItem}>
//                                                         <div className={styles.siteDetailText}>{assignment.service_fee || '1500.00'}</div>
//                                                     </div>
//                                                     <div className={styles.siteAssignmentItem}>
//                                                         <div className={styles.siteDetailText}>{assignment.consent_template || 'Template -1'}</div>
//                                                     </div>
//                                                 </div>
//                                             ))
//                                         ) : (
//                                             <div className={styles.noSites}>No site assignments found</div>
//                                         )}
//                                     </div>
//                                 </td>
//                             </tr>
//                         )}
//                     </React.Fragment>
//                 ))}
//             </tbody>
//         </table>
//     );
// };

// export default UserTable;

import React from 'react';
import styles from './UserManagement.module.css';

const UserTable = ({ users, loading, onEdit, onDelete, onHistory, expandedUserId, onToggleRow }) => {
    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.split(' ');
        return parts.length >= 2 ? (parts[0][0] + parts[1][0]).toUpperCase() : name.substring(0, 2).toUpperCase();
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '40px', fontSize: '16px', color: '#666' }}>
                Loading users...
            </div>
        );
    }

    if (users.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                No users found
            </div>
        );
    }

    return (
        <table className={styles.table}>
            <thead className={styles.tableHead}>
                <tr>
                    <th style={{ width: '50px' }}></th>
                    <th>Full Name</th>
                    <th>Contact Number</th>
                    <th>Role</th>
                    <th>Study</th>
                    {/* <th>Assigned Sites</th> */}
                    <th>Status</th>
                    <th className={styles.actionsColumn}>Actions</th>
                </tr>
            </thead>
            <tbody className={styles.tableBody}>
                {users.map((user) => {
                    const isExpanded = expandedUserId === user.user_id;
                    return (
                        <React.Fragment key={user.user_id}>
                            <tr className={styles.tableRow}>
                                <td>
                                    <button
                                        className={styles.expandButton}
                                        onClick={() => {
                                            console.log('Clicked user_id:', user.user_id, 'Current expanded:', expandedUserId, 'Match:', expandedUserId === user.user_id);
                                            onToggleRow(user.user_id);
                                        }}
                                    >
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            className={isExpanded ? styles.expandedIcon : ''}
                                        >
                                            <polyline points="9 18 15 12 9 6" />
                                        </svg>
                                    </button>
                                </td>
                                <td>
                                    <div className={styles.userCell}>
                                        <div className={styles.avatar}>{getInitials(user.full_name)}</div>
                                        <div className={styles.userInfo}>
                                            <div className={styles.userName}>{user.full_name}</div>
                                            <div className={styles.userEmail}>{user.email_address}</div>
                                        </div>
                                    </div>
                                </td>
                                <td>{user.contact_number || '-'}</td>
                                <td><span className={styles.roleBadge}>{user.role_name || '-'}</span></td>
                                <td>{user.study_title || '-'}</td>
                                {/* <td>
                                    <span className={styles.sitesCount}>
                                        {user.assigned_sites?.length || 0} {user.assigned_sites?.length === 1 ? 'site' : 'sites'}
                                    </span>
                                </td> */}
                                <td>
                                    <span className={`${styles.statusBadge} ${user.status === 'Active' ? styles.statusActive : styles.statusInactive}`}>
                                        {user.status}
                                    </span>
                                </td>
                                <td>
                                    <div className={styles.actionIcons}>
                                        <button className={styles.iconButton} onClick={() => onEdit(user)} title="Edit">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                            </svg>
                                        </button>
                                        <button className={styles.iconButton} onClick={() => onDelete(user)} title="Delete">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <polyline points="3 6 5 6 21 6" />
                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                            </svg>
                                        </button>
                                        <button className={styles.iconButton} onClick={() => onHistory(user)} title="History">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12 6 12 12 16 14" />
                                            </svg>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            {isExpanded && (
                                <tr className={styles.expandedRow}>
                                    <td colSpan="8">
                                        <div className={styles.expandedContent}>
                                            <div className={styles.siteAssignmentsHeader}>
                                                <div className={styles.siteHeaderItem}>
                                                    <span className={styles.headerLabel}>Study Details</span>
                                                </div>
                                                <div className={styles.siteHeaderItem}>
                                                    <span className={styles.headerLabel}>Site Details</span>
                                                </div>
                                                <div className={styles.siteHeaderItem}>
                                                    <span className={styles.headerLabel}>Max. Subjects</span>
                                                </div>
                                                <div className={styles.siteHeaderItem}>
                                                    <span className={styles.headerLabel}>Currency</span>
                                                </div>
                                                <div className={styles.siteHeaderItem}>
                                                    <span className={styles.headerLabel}>Service Fee</span>
                                                </div>
                                                <div className={styles.siteHeaderItem}>
                                                    <span className={styles.headerLabel}>Consent Template</span>
                                                </div>
                                            </div>
                                            {user.assigned_sites && user.assigned_sites.length > 0 ? (
                                                user.assigned_sites.map((assignment, index) => (
                                                    <div key={index} className={styles.siteAssignmentRow}>
                                                        <div className={styles.siteAssignmentItem}>
                                                            <div className={styles.siteDetailText}>{assignment.study_number || 'N/A'}</div>
                                                            <div className={styles.siteDetailSubtext}>{assignment.study_name || 'N/A'}</div>
                                                        </div>
                                                        <div className={styles.siteAssignmentItem}>
                                                            <div className={styles.siteDetailText}>{assignment.site_code || 'N/A'}</div>
                                                            <div className={styles.siteDetailSubtext}>{assignment.site_name || 'N/A'}</div>
                                                        </div>
                                                        <div className={styles.siteAssignmentItem}>
                                                            <div className={styles.siteDetailText}>{assignment.max_subjects || '20'}</div>
                                                        </div>
                                                        <div className={styles.siteAssignmentItem}>
                                                            <div className={styles.siteDetailText}>{assignment.currency || 'USD'}</div>
                                                        </div>
                                                        <div className={styles.siteAssignmentItem}>
                                                            <div className={styles.siteDetailText}>{assignment.service_fee || '1500.00'}</div>
                                                        </div>
                                                        <div className={styles.siteAssignmentItem}>
                                                            <div className={styles.siteDetailText}>{assignment.consent_template || 'Template -1'}</div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className={styles.noSites}>No site assignments found</div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    );
                })}
            </tbody>
        </table>
    );
};

export default UserTable;